import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ContactListObject, DetailedStateObj, ContactStateDescriptionItem } from './contact-list.models';

@Injectable({
    providedIn: 'root'
})
export class ContactListService {
    constructor(private cvApiService: CVApiService) { }

    async loadData(moduleKey: string, isAutoRefresh = false, isFirstLoad = false, isCXOne = false, cancellerPromise?: Promise<void>){
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const query = `/api/v2/realtime/contactlist/getcontactlistdata/`;
            const queryAll = query + `${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}&isCXOne=${isCXOne}`;
            const response = await this.cvApiService.get(queryAll, renderEndpoint, cancellerPromise) as ApiResponse<ContactListObject>;

            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        }
        catch (err) {
            if (err?.code === DOMException.ABORT_ERR || err?.statusText === 'abort') {
                throw err;
            }
            console.error('Failed to load contact list data');
            throw err;
        }
    }

    async LoadDetailedData(contactID: string, moduleKey: string): Promise<DetailedStateObj> {
        try {
            const url = "../api/v2/realtime/contactlist/getcontactlistdetaileddata/";
            const response = await this.cvApiService.get<DetailedStateObj>(url + `${contactID}?moduleKey=${moduleKey}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error('Failed to load contact list data');
            throw err;
        }
    }

    async loadDescriptions() {
        const url = "/api/v2/realtime/contactlist/contact-state-descriptions";
        const response = await this.cvApiService.get<ContactStateDescriptionItem[]>(url);
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        else
            throw response;
    }
}
